import React from "react";
import { useWatch } from "react-hook-form";

import { AutoFormFieldProps } from "@autoform/react";

import { Input } from "@/components/ui/input";

export function SlugField({ id, inputProps, error }: AutoFormFieldProps) {
  const status = useWatch({ name: "status" });
  const { key, ...rest } = inputProps;

  return (
    <Input
      id={id}
      className={error ? "border-destructive" : ""}
      disabled={status === "Complete" || rest.disabled}
      {...rest}
    />
  );
}
